import api from './api';

/**
 * Get all users with optional filters
 * @param {Object} params - Query parameters (page, limit, status, search)
 * @returns {Promise<Object>} Users list with pagination
 */
export const getUsers = async (params = {}) => {
  const response = await api.get('/admin/users', { params });
  return response.data;
};

/**
 * Get user statistics
 * @returns {Promise<Object>} User stats (total, active, blocked)
 */
export const getUserStats = async () => {
  const response = await api.get('/admin/users/stats');
  return response.data;
};

/**
 * Get a single user by ID
 * @param {number} id - User ID
 * @returns {Promise<Object>} User object with counts
 */
export const getUserById = async (id) => {
  const response = await api.get(`/admin/users/${id}`);
  return response.data;
};

/**
 * Block a user
 * @param {number} id - User ID
 * @returns {Promise<Object>} Updated user
 */
export const blockUser = async (id) => {
  const response = await api.put(`/admin/users/${id}/block`);
  return response.data;
};

/**
 * Unblock a user
 * @param {number} id - User ID
 * @returns {Promise<Object>} Updated user
 */
export const unblockUser = async (id) => {
  const response = await api.put(`/admin/users/${id}/unblock`);
  return response.data;
};

/**
 * Permanently delete a user and all their content
 * @param {number} id - User ID
 * @returns {Promise<Object>} Deletion result
 */
export const deleteUser = async (id) => {
  const response = await api.delete(`/admin/users/${id}`);
  return response.data;
};

const usersService = {
  getUsers,
  getUserStats,
  getUserById,
  blockUser,
  unblockUser,
  deleteUser
};

export default usersService;
